import { AbstractControl, ValidatorFn } from '@angular/forms';
import { DateTime } from "luxon";

export function ValidDate(format: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const regex = new RegExp('\\d{2}\\/\\d{2}\\/\\d{4}')
    const validFormat = DateTime.fromFormat(control.value, format).isValid
    const valid = (validFormat && regex.test(control.value)) || control.value.length == 0;
    return valid ? null : { 'invalidDate': { value: control.value } };
  };
}
